import React, { useEffect } from "react";
import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { UserMap } from "../../components/maps/MapCustom";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Location from "../../location/Location";
import { useDispatch, useSelector } from "react-redux";
import {Settracking} from "../../redux/counterSlice";
// import   useLocationContext  from '../../contextapi/LocationContext';
import { useGetLocation } from '../../contextapi/SendLcationContaxt';

export default () => {
 
const {setcampaign_id,setvehicle_id,settracking}=useGetLocation()
  const[spiner,setspiner]=useState(false)
  const [isFetching, setIsFetching] = useState(false);
  const [trackingcam,settrackingcam]=useState(false)
  const [preroutes,setpreroutes]=useState([])



// console.log(useGetLocation)
  const dispatch = useDispatch();
  // const tracking = useSelector((state) => state.auth.tracking);

 
 

  const stopTracking = () => {  
    // dispatch(Settracking(false));
    settrackingcam(false)

  };
   
 
  console.log(isFetching)
  const [data, setData] = useState({
    before_installation: "",
    after_installation: "",
    during_campaign: "",
    after_removel: "",
    special_events: "",
  });

  const location=useLocation()
  const {id ,vechile_id}=location.state
  // console.log(id,'yyyyyyyyyyyyyy')



  console.log(data, "dd");
  const handleChange = (key, value) => {
    console.log(key, value, "bdhb");
    setData({ ...data, [key]: value });
  };

 
    





  const { request, loading, error } = useApi((formData) =>
 
     apiClient.patch(`/campaign/campaign-details/${id}/`, formData)
  );
  useEffect(() => {

    try {
      const fetch = async () => {
        setspiner(true)

    const response = await apiClient.get(`/campaign/campaign-details/${id}/`);
    setspiner(false)

if(!response.ok)return



    const data = response.data;
 
  

    setData(data);



  };
  fetch();
    } catch (error) {
      console.log(error)
    }
   
  }, []);
  function idgetfung() {
    // setcampaign_id(data.data)
    console.log(data.id)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
 
    if (data.before_installation && data.before_installation.file) {
  ;
      formData.append("before_installation_image", data.before_installation);
    }
    if (data.after_installation && data.after_installation.file) {
  ;
  formData.append("after_installation_image", data.after_installation);
    }
    if (data.during_campaign && data.during_campaign.file) {
  ;
  formData.append("during_campaign_image", data.during_campaign);
    }
    if ( data.after_removel &&  data.after_removel.file) {
  ;
  formData.append("after_removal_image", data.after_removel);
    }

   
  
    

    if (data.special_events &&  data.special_events.file) {
      ;
      formData.append("special_events", data.special_events);
        }
   
  
    // formData.append("swarm_date_time","2022-11-2");
   


    const result = await request(formData);
    if (!result.ok) return toast.error("Error");
    toast.success("Campaign Succesfully Created");
    fetch()

  };

 



  // const fetch = async () => {
  //   // setLoading(true);
   
  //     const response = await apiClient.get(`/campaign/campaign-details/${id}/`);
  //     // setLoading(false)

  //     if(!response.ok) return console.log("error")
  //     console.log("aucess")
  //     if (response.ok) {
  //       const data = response.data;
  //       // setnewreq(response?.data);
  //     console.log(response?.data)}
  //     setcompaing(response?.data)
 
      
  // };


  const startTracking = () => {

    // dispatch(Settracking(true));
    settrackingcam(true)

    setcampaign_id(data.id)
    setvehicle_id(vechile_id)

    console.log(data.id,"tracking")
   
  };
  const fetchsavelocation= async()=>{

    const response =  await apiClient.get(`/campaign/tracking/?vehicle_id=${vechile_id}`);
    console.log(response.data,"response");
    setpreroutes(response.data)

  }

  
   useEffect(()=>{
    fetchsavelocation()
   },[vechile_id])

   useEffect(()=>{
    settracking(trackingcam)
   },[trackingcam])

  return (

    
    <div>
      {!spiner ? <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-sm-2 p-1">


            <div className="site-content-body">
              <div className="container-fluid main_bg_color">
                <div className="row">
                  <div className="col-md-8 px-md-2">
                    <div>
                      {/* Carousel */}
                      <div
                       
                      >
                        {/* The slideshow/carousel */}
                        <div className="carousel-inner test-2">
                          <div className=" carousel-item active">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> {data.start_date}</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>{data.end_date}</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> {data.total_miles} Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> {data.total_hours} Hours</span>
                                  </p>
                                  {/* <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> {data.total_impression}</span>
                                  </p> */}
                                  {/* <p>
                                    <span className="fw-bold">EARNINGS:</span>
                                    <span className=""> ${data.earnings}</span>
                                  </p> */}
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={data?.before_installation_image}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="  ">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> 11/08/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>11/18/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> {data?.total_miles} Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> {data?.total_hours} Hours</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> {data?.total_impression}</span>
                                  </p>
                                  {/* <p>
                                    <span className="fw-bold">EARNINGS:</span>
                                    <span className=""> ${data.earnings}</span>
                                  </p> */}
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={data?.after_installation_image}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className=" carousel-item ">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> 11/08/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>11/18/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> {data.total_miles} Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> {data.total_hours} </span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> {data.total_impression}</span>
                                  </p>
                                 
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={data.during_campaign_image}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {/* <div className=" carousel-item">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> 11/08/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>11/18/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> {data.total_miles} Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> {data.total_hours} Hours</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> {data.total_impression}</span>
                                  </p>
                                
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={data.after_removal_image}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div> */}
                          {/* <div className="carousel-item">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> 11/08/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>11/18/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> 503 Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> 10 Hours</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> 102,320</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">EARNINGS:</span>
                                    <span className=""> $450.00</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={require("../../assets/img/active_nike.png")}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="row d-md-flex py-1 slider_border_radius">
                              <div className="col-md-6 px-2">
                                <div className=" slider_line_height text_color">
                                  <div className="d-flex message_dot_Posetion">
                                    <span className="bottom_line mb-3">
                                      <h5 className>Details</h5>
                                    </span>
                                  </div>
                                  <p>
                                    <span className="fw-bold">Start Date:</span>
                                    <span> 11/08/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">End Date:</span>
                                    <span>11/18/2022</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Miles:
                                    </span>
                                    <span> 503 Miles</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Hours:
                                    </span>
                                    <span> 10 Hours</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">
                                      Total Impressions:
                                    </span>
                                    <span> 102,320</span>
                                  </p>
                                  <p>
                                    <span className="fw-bold">EARNINGS:</span>
                                    <span> $450.00</span>
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-6 px-2">
                                <div className="slider_img_height">
                                  <img
                                    src={require("../../assets/img/active_nike.png")}
                                    className=" img-fluid h-100 w-100"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        {/* <button
                          className="carousel-control-next carousel_errow test"
                          type="button"
                          data-bs-target="#demo"
                          data-bs-slide="next"
                        >
                          <i className="bi bi-chevron-right fa-3x right_errow" />
                        </button> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 px-md-2 mt-md-0 mt-2">
                    <div className=" bg_more_deatils text_color p-3">
                      <span className="bottom_line mb-3">
                        <h5 className>Confirmed Requests</h5>
                      </span>
                      <p>
                        <span className="fw-bold">Install :</span>
                        {/* <span>11/07/2022;</span>
                        <span> @2:00 pm</span> */}
                         <span> {data?.install_date_time}</span>
                      </p>
                      <p>
                        <span className="fw-bold">Photoshoot:</span>
                        {/* <span>11/16/2022;</span>
                        <span> @4:00 pm</span> */}
                    <span>{data?.photoshoot_date_time}</span>
                      </p>
                      <p>
                        <span className="fw-bold">Swarm:</span>
                        {/* <span> 11/16/2022;</span>
                        <span>@3:00 pm</span> */}
                           <span>{data?.swarm_date_time}</span>
                        {/* <span>@3:00 pm</span> */}
                      </p>
                      <p>
                        <span className="fw-bold">Repair:</span>
                        {/* <span> 11/16/2022;</span>
                        <span>@3:00 pm</span> */}
                        
                           <span>{data?.repair_date_time}</span>
                        {/* <span>@3:00 pm</span> */}
                      </p>
                    
                      <p>
                        <span className="fw-bold">Removal:</span>
                        {/* <span> 11/21/2022;</span>
                        <span>@1:30 pm</span> */}
                        <span> {data?.removal_date_time} </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className=" col-lg-5 col-md-6 px-md-2 my-2">
                    <div className="test-2 ">
                      <div className="bg_Map pt-2 pb-3 d-flex gap-3">
                        <span className="bottom_line ms-3">
                          <h5 className>Vehicle locations</h5>
                        </span>
                     <button className="btn" disabled={trackingcam} style={{backgroundColor:"#D0DDE6"}} onClick={startTracking}> Start</button>
                     <button className="btn px-3" disabled={!trackingcam}  style={{backgroundColor:"#ff968c"} } onClick={stopTracking}> End</button>
                      </div>
                      <div style={{ width: "100%", height: 310 }}>
                        <UserMap  preroutes={preroutes}/>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <div className="row">
                      <div className="col-12 p-md-2">
                        <div className="test-2 pt-2 bg-white">
                          <span className="bottom_line ms-3">
                            <h5 className>Campaign Photos</h5>
                          </span>
                          <form action>
                            <div className="px-3 py-2 d-flex">
                              <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                <i className="bi bi-file-earmark-ruled-fill" />
                                <br />
                                <label htmlFor="before_installation">
                                  Upload Files Here
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  hidden
                                  name
                                  id="before_installation"
                                  onChange={(e) =>
                                    handleChange(
                                      "before_installation",
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </div>
                              {data?.before_installation ? (
                                <img
                                  className="img-fluid w-25"
                                  src={data?.before_installation}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              <div className="w-50 my-auto ps-lg-0 ps-3">
                                <h5>Before Installation</h5>
                              </div>
                            </div>
                            <div className="px-3 py-2 d-flex">
                              <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                <i className="bi bi-file-earmark-ruled-fill" />
                                <br />
                                <label htmlFor="after_installation">
                                  Upload Files Here
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  hidden
                                  name
                                  id="after_installation"
                                  onChange={(e) =>
                                    handleChange(
                                      "after_installation",
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </div>
                              {data?.after_installation ? (
                                <img
                                  className="img-fluid w-25"
                                  src={data?.after_installation}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              <div className="w-50 my-auto ps-lg-0 ps-3">
                                <h5>After Installation</h5>
                              </div>
                            </div>
                            <div className="px-3 py-2 d-flex">
                              <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                <i className="bi bi-file-earmark-ruled-fill" />
                                <br />
                                <label htmlFor="during_campaign">
                                  Upload Files Here (min.15)
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  hidden
                                  name
                                  id="during_campaign"
                                  onChange={(e) =>
                                    handleChange(
                                      "during_campaign",
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </div>
                              {data?.during_campaign ? (
                                <img
                                  className="img-fluid w-25"
                                  src={data?.during_campaign}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              <div className="w-50 my-auto ps-lg-0 ps-3">
                                <h5>During Campaign</h5>
                              </div>
                            </div>
                            <div className="px-3 py-2 d-flex">
                              <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                <i className="bi bi-file-earmark-ruled-fill" />
                                <br />
                                <label htmlFor="after_removel">
                                  Upload Files Here
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  hidden
                                  name
                                  id="after_removel"
                                  onChange={(e) =>
                                    handleChange(
                                      "after_removel",
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </div>
                              {data?.after_removel ? (
                                <img
                                  className="img-fluid w-25"
                                  src={data?.after_removel}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              <div className="w-50 my-auto ps-lg-0 ps-3">
                                <h5>After Removal</h5>
                              </div>
                            </div>
                            <div className="px-3 py-2 d-flex">
                              <div className="text-center mx-lg-4 py-2 img_input_color w-50">
                                <i className="bi bi-file-earmark-ruled-fill" />
                                <br />
                                <label htmlFor="special_events">
                                  Upload Files Here
                                </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  hidden
                                  name
                                  id="special_events"
                                  onChange={(e) =>
                                    handleChange(
                                      "special_events",
                                      e.target.files[0]
                                    )
                                  }
                                />
                              </div>
                          
                              {data?.special_events ? (
                                <img
                                  className="img-fluid w-25"
                                  src={data?.special_events}
                                  alt=""
                                />
                              ) : (
                                ""
                              )}
                              <div className="w-50 my-auto ps-lg-0 ps-3">
                                <h5 className="text-primary">Special Event</h5>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                  <button className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0">
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Location isFetching={isFetching}  campaign_id={data.id}  /> */}

      </form>
      
      : <div className="d-flex justify-content-center align-items-center" style={{height:"60vh"}}>
  <CircularProgress className="" />
      </div> }
    </div>
  );
};
